import { AVAILABILITY_IMAGE_CELL, AVAILABILITY_IMAGE_CELL_LABELS } from '../../constants/bookingConst';

/**
 * One cell of the full-grid images, drawn like the guest booking grid's slot
 * button: OPEN / BOOKED / PASSED / CLOSED as a single word, Open Play as the
 * blue two-line cell, and a promo hour with the corner ribbon and its price.
 * Styles live in AvailabilityGuestGrid.css.
 * @param {object} props
 * @param {{status: string, promo: boolean, price: string}} props.cell - a snapshot cell
 * @returns {JSX.Element}
 */
function GuestStyleCell({ cell }) {
  const status = cell?.status || AVAILABILITY_IMAGE_CELL.CLOSED;
  if (status === AVAILABILITY_IMAGE_CELL.OPEN_PLAY) {
    return (
      <div className="agg-slot agg-slot-openPlay">
        <span className="agg-op-main">Open Play</span>
        {/* The guest grid says "(Click to join)"; a picture can't be
            clicked, so the image points to the booking site instead. */}
        <span className="agg-op-sub">(Join online)</span>
      </div>
    );
  }
  if (cell?.promo) {
    return (
      <div className="agg-slot agg-slot-open agg-slot-promo">
        <span className="agg-promo-label">Promo</span>
        <span className="agg-slot-status">{AVAILABILITY_IMAGE_CELL_LABELS.open}</span>
        {cell.price && <span className="agg-promo-price">{cell.price}</span>}
      </div>
    );
  }
  return (
    <div className={`agg-slot agg-slot-${status}`}>
      <span className="agg-slot-status">{AVAILABILITY_IMAGE_CELL_LABELS[status] || ''}</span>
    </div>
  );
}

export default GuestStyleCell;
